import { delete0, get, post, postForm } from '@/utils/request'

const zhihuApi = {
  zhihu: '/api/spider/zhihu'
}

export function getQuestions(queryInfo) {
  return get(zhihuApi.zhihu + '/questions', queryInfo)
}

export function getQuestion(queryInfo) {
  return get(zhihuApi.zhihu + '/question', queryInfo)
}

export function getAnswer(queryInfo) {
  return get(zhihuApi.zhihu + '/answer', queryInfo)
}

export function getComment(queryInfo) {
  return get(zhihuApi.zhihu + '/comment', queryInfo)
}

export function getChildComment(queryInfo) {
  return get(zhihuApi.zhihu + '/child_comment', queryInfo)
}
